import CoordinatorBase from './../shared/coordinator-base';
import { computed } from 'mobx';
import { serializable } from 'serializr';
import _ from 'lodash';

class Coordinator extends CoordinatorBase {
    constructor(...args) {
        super(...args);
    }

    @serializable roles = [];
    @serializable credentials = [];

    @computed
    get text() {
        return this.name + '-' + this.email;
    }

    hasRole(roleName) {
        return _.some(this.roles, { name: roleName });
    }

    @computed
    get hasGoogleCredentials() {
        return _.find(this.credentials, { provider: 'google' });
    }
    @computed get role() {
        if (this.roles && this.roles.length > 0) {
            return this.roles[0].name;
        } else {
            return '';
        }
    }

    @computed
    get profile() {
        const credential = _.find(this.credentials, { provider: 'google' });
        if (!credential) return {};
        return {
            email: _.find(credential.profile.emails) ? _.find(credential.profile.emails).value : null,
            photo: _.first(credential.profile.photos) ? _.first(credential.profile.photos).value : null,
        };
    }
}

export default Coordinator;



// WEBPACK FOOTER //
// ./src/coordinators/coordinator-model.js